import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const fmtD = (y, m, d) => `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

export const ledgerRangeFor = (key) => {
  const now = new Date(); const y = now.getFullYear(); const m = now.getMonth();
  const today = fmtD(y, m + 1, now.getDate());
  if (key === "month") return { key, from: fmtD(y, m + 1, 1), to: today };
  if (key === "quarter") return { key, from: fmtD(y, m - (m % 3) + 1, 1), to: today };
  if (key === "fy") { const fy = m >= 3 ? y : y - 1; return { key, from: fmtD(fy, 4, 1), to: today }; }
  return { key: "all", from: "", to: "" };
};

const RANGE_CHIPS = [["all", "All Time"], ["month", "This Month"], ["quarter", "This Quarter"], ["fy", "This FY"]];

const DatePick = ({ label, value, onChange, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
                className={`inline-flex items-center gap-1.5 h-8 text-xs border rounded-md px-2.5 bg-white transition-colors duration-150 ${
                  value ? "border-[#3B82F6]/40 text-[#3B82F6] font-semibold" : "border-slate-200 text-slate-400 hover:border-slate-400"}`}>
          <CalendarIcon size={12} />
          {value ? format(new Date(value), "dd/MM/yyyy") : label}
          {value && (
            <X size={11} className="text-slate-400 hover:text-rose-500"
               onClick={(e) => { e.stopPropagation(); onChange(""); }} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={value ? new Date(value) : undefined}
                  onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
};

export const LedgerRangeBar = ({ lr, onApply }) => (
  <div className="flex flex-wrap items-center gap-1.5" data-testid="ledger-range-bar">
    {RANGE_CHIPS.map(([k, label]) => (
      <button key={k} onClick={() => onApply(ledgerRangeFor(k))}
              className={`text-xs font-semibold rounded-full px-3 py-1.5 border transition-colors duration-200 ${
                lr.key === k ? "bg-[#3B82F6] text-white border-[#3B82F6]" : "bg-white text-slate-500 border-slate-200 hover:border-slate-400"}`}
              data-testid={`ledger-range-${k}`}>{label}</button>
    ))}
    <DatePick label="From" value={lr.from} onChange={(v) => onApply({ key: "custom", from: v, to: lr.to })} testid="ledger-range-from" />
    <DatePick label="To" value={lr.to} onChange={(v) => onApply({ key: "custom", from: lr.from, to: v })} testid="ledger-range-to" />
  </div>
);
